import { __assign, __rest } from "tslib";
import React from 'react';
var FlipItem = function (props) {
    var className = props.className, children = props.children, otherProps = __rest(props, ["className", "children"]);
    return (React.createElement("div", __assign({}, otherProps, { className: className }), children));
};
FlipItem.displayName = 'FlipItem';
export default FlipItem;
//# sourceMappingURL=flip-item.js.map